export class UrlConstant {
  public static readonly SYSTEM_PREFIX = "/system";
  public static readonly APP_PREFIX = "/app";

  public static readonly GET_CSRF = '/csrf-token';
  public static readonly AUTHENTICATION = {
    PREFIX: '/auth',
    LOGIN: '/sign-in',
    LOGOUT: '/sign-out',
    REFRESH_TOKEN: '/refresh-token'
  }
  public static readonly MENU = {
    PREFIX: UrlConstant.SYSTEM_PREFIX + '/menus',
    LIST: '/list',
    LIST_BY_TREE: '/list-by-tree',
    LIST_BY_CURRENT_USER: '/list-menus-by-current-user',
    CREATE: '/add',
    UPDATE: '/update',
    DELETE_BY_ID: '/delete/{menu_id}',
    SEARCH_BY_NAME: '/search-by-name',
    GET_MENU_BY_ID: '/{menuId}',
    UN_OR_ASSIGN_ROLE: '/{menuId}/un-or-assigned-role',
    SEARCH_BY_PARENT_ID: '/search-by-parent-id',
  };

  public static readonly FRONTEND_MENU = {
    PREFIX: UrlConstant.APP_PREFIX + '/frontend-menus',
    LIST: '/list',
    GET: '/get/{menuType}',
    CONFIG: '/config',

  }

  public static readonly CURRENT_USER = {
    PREFIX: '/current-user',
    MENUS: '/menus',
    PROFILE: '/user-info',
    CHANGE_PROFILE: '/change-user-info',
    CHANGE_PASS: '/change-password',
    CAN_ACCESS_MENU: '/can-access-menu',
    SITES: '/get-sites'
  }

  public static readonly PRIVATE_FILES = {
    PREFIX: '/private-files',
    DOWNLOAD: '/{filename}',
    UPLOAD_TINYMCE: '/editor-upload',
  }

  public static readonly PUBLIC_FILES = {
    PREFIX: '/public-files',
    DOWNLOAD: '/{filename}',
  }

  public static readonly USER = {
    PREFIX: UrlConstant.SYSTEM_PREFIX +'/users',
    LIST: '/list',
    VERIFY: '/{userId}/verify',
    ADD: '/add',
    EDIT: '/{userId}/edit',
    LOCK_UNLOCK: '/{userId}/lock-unlock',
    DELETE: '/{userId}/delete',
    GET_ROLE_CAN_SEE: '/{userId}/get-role-can-see',
    UN_OR_ASSIGN_SITE: '/{userId}/sites/{websiteId}/un-or-assigned-website',
    REGISTER_FCM_TOKEN: '/register-fcm-token',
  }


  public static readonly ORDER = {
    PREFIX: UrlConstant.APP_PREFIX + '/order',
    LIST: '/getList',
    ADD: '/add',
    EDIT: '/edit',
    DELETE: '/delete',
    UPDATE_SHIPPED: '/updateShipped',
    UPDATE_PRINT: '/updatePrint',
  }
  public static readonly REPORT = {
    PREFIX: UrlConstant.APP_PREFIX + '/report',
    SUMMARY_ORDER: '/summaryOrder',
  }

  public static readonly NOTIFICATION = {
    PREFIX: UrlConstant.APP_PREFIX + '/notification',
    GET_HISTORY: '/getHistory',
  }
}
